import { Component, Input, OnInit } from '@angular/core';
import { User } from '../../../models/User';
import { RMA } from '../../../models/RMA';
import { RMAItem } from '../../../models/RMAItem';
import { RMAResponse } from '../../../models/RMAResponse';
import { GlobalService } from '../../../services/global';
import { HttpService } from '../../../services/HttpService';

@Component({
  selector: 'app-rma-respond',
  templateUrl: './rma-respond.component.html',
  styleUrls: ['./rma-respond.component.css']
})
export class RmaRespondComponent implements OnInit {
  @Input() RMA: RMA;
  @Input() RMAItem: RMAItem;
  Response: RMAResponse;
  CurrentFile: FormData;
  CurUser: User;
  HidePONum: boolean;
  PONum: string;
  HidePOValidation: boolean;
  constructor(private http:HttpService, private global:GlobalService) { }

  ngOnInit(): void {
    this.HidePONum = true;
    this.HidePOValidation = true;
    this.Response = new RMAResponse();
    this.Response.RMANumber = this.RMA.RMANumber;
    this.Response.RMAItem = this.RMAItem;
    this.Response.RMAItemRowPointer = this.RMAItem.RMAItemRowPointer;
    this.global.getCurrentUser().then(x => {
      this.CurUser = x;
    });
    this.Response.UserID = this.CurUser.UserId.toString();
    this.global.getCurrentDist().then(dist => {
      this.http.PostUserActivity(this.CurUser.UserId.toString(), "RMA Respond", "Load", "", this.CurUser.IsTolomaticUser ? dist.CompanyId : this.CurUser.DistributorId);
    });
    
  }
  Validate(): boolean {
    this.Response.UserID = this.CurUser.UserId.toString();
    this.HidePOValidation = true;
    if (this.Response.Action == "Rpr" && this.Response.PONumber.length == 0) {
      this.HidePOValidation = false;
      return false;
    }
    else {
      return true;
    }
  }


  SubmitResponse() {
    if (this.Response.Action != "" && this.RMA != null) {
      this.Response.RMANumber = this.RMA.RMANumber + '-' + this.RMAItem.RMALine.toString();
      this.Response.TakenByEmail = this.RMA.TakenByEmail;
      this.http.SubmitRMAResponse(this.Response, this.CurUser.UserId.toString()).then(x => {
        if (x.StatusCode == "200") {

        }
      });
    }
  }

  onFileSelected(event) {
    let file = <File>event.target.files[0];
    debugger;

    if (file) {
      this.Response.POFileName = file.name;
      this.CurrentFile = new FormData();
      this.CurrentFile.append('file', file, file.name);
      this.Response.POFile = file;
    }
  }

}
